import { resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ticket-type-section"
}
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_Error = _resolveComponent("Error")!

  return (!_ctx.showError)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_Transition, {
          tag: "div",
          name: "fade",
          class: "ticket-type-section__item"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Select, {
              labelClassName: "ticket-type-section__label",
              wrapperClassName: "ticket-type-section__select-wrapper",
              className: "ticket-type-section__select",
              label: _ctx.translate('shop.ticket.configuration.Choose Ticket Type Title'),
              id: "ticketType",
              name: "ticketType",
              placeholder: _ctx.translate('shop.ticket.configuration.Choose Ticket Type Title'),
              modelValue: _ctx.selectedTicketType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTicketType) = $event)),
              selectedOption: _ctx.selectedTicketType,
              description: _ctx.selectedTicketTypeDescription,
              options: _ctx.ticketTypesOptions
            }, null, 8, ["label", "placeholder", "modelValue", "selectedOption", "description", "options"])
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_Transition, {
          tag: "div",
          name: "fade",
          class: "ticket-type-section__item mt-md-5 mt-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Select, {
              labelClassName: "ticket-type-section__label",
              wrapperClassName: "ticket-type-section__select-wrapper",
              className: "ticket-type-section__select",
              label: _ctx.selectedSubTypes.title,
              id: "ticketSubType",
              name: "ticketSubType",
              placeholder: _ctx.translate('shop.ticket.configuration.Choose Ticket Sub Type Title'),
              modelValue: _ctx.selectedTicketSubType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTicketSubType) = $event)),
              selectedOption: _ctx.selectedTicketSubType,
              description: _ctx.selectedTicketSubTypeDescription,
              options: _ctx.selectedSubTypes.options
            }, null, 8, ["label", "placeholder", "modelValue", "selectedOption", "description", "options"])
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.selectedSubTypes.types.length > 1]
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_Error, { errorMessage: _ctx.errorMessage }, null, 8, ["errorMessage"])
      ]))
}